import "./provide-feedback-modal.scss";

import { MenuItem, SxProps } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NAMESPACES } from "@/i18n/constants";

import { ProvideFeedbackModal } from "./provide-feedback-modal";

interface ProvideFeedbackButtonProps {
    onClick?: () => void;
    children?: React.ReactNode;
    sx?: SxProps;
}
export function ProvideFeedbackButton({ onClick, children, sx }: ProvideFeedbackButtonProps) {
    const { t } = useTranslation(NAMESPACES.FEATURES.NAVIGATION, {
        keyPrefix: "provide-feedback-modal.provide-feedback-button",
    });
    const [open, setOpen] = useState(false);

    return (
        <>
            <MenuItem
                key={`SettingsMenu_provideFeedback`}
                sx={{
                    minWidth: "100px",
                    ...sx,
                }}
                onClick={() => {
                    if (onClick) {
                        onClick();
                    }
                    setOpen(true);
                }}
            >
                {children || t("feedback-btn-title")}
            </MenuItem>

            <ProvideFeedbackModal
                open={open}
                handleClose={() => {
                    setOpen(false);
                }}
            />
        </>
    );
}
